// utils/cohortSwitcher.js — Anamoria SPA
// v0.1 — NEW-171 Phase 3 (SPA PR-2): pure logic for the leader group switcher (gate + partition).
//
// The switcher lists the groups the caller leads (GET /leader/groups), shown only to a multi-group
// leader with 2+ groups. The gate + ordering live here, pure and tested, so LeaderPage only renders.
// Internal module — user-facing copy never says "cohort"; these are the leader's GROUPS.

/**
 * Whether the switcher control should be shown at all.
 * Hidden unless the multi_cohort_leader flag is on (dashboard.multiCohortEnabled) AND the caller
 * leads 2+ groups. Single-group or flag-off leaders see the plain title (today's behaviour).
 * @param {boolean} multiCohortEnabled
 * @param {Array} groups GET /leader/groups → [{ groupId, name, pilotStatus, ... }]
 * @returns {boolean}
 */
export function shouldShowSwitcher(multiCohortEnabled, groups) {
  return multiCohortEnabled === true && Array.isArray(groups) && groups.length >= 2;
}

/**
 * Split the leader's groups into the active list and the "Past" list (ended groups).
 * "Past" = pilotStatus 'completed'. Everything else (active, not_started) stays in `active`,
 * preserving the order the backend returns (active-first then start date — handleGetGroups).
 * @param {Array} groups
 * @returns {{ active: Array, past: Array }}
 */
export function partitionCohorts(groups) {
  const list = Array.isArray(groups) ? groups : [];
  const active = [];
  const past = [];
  for (const g of list) {
    if (g && g.pilotStatus === 'completed') past.push(g);
    else active.push(g);
  }
  return { active, past };
}
